function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-966 -200) translate(166 194) translate(800 6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB506E",
  fillRule: "nonzero",
  d: "M10.955 2c-.646 0-1.28.126-1.74.576-.458.45-.603 1.09-.603 1.753H5.545c-.425 0-.772.345-.772.768H4v1.537h17V5.097h-.773c0-.423-.347-.768-.772-.768h-3.067c0-.663-.145-1.303-.604-1.753-.459-.45-1.093-.576-1.739-.576h-3.09zm0 1.585h3.09c.423 0 .556.099.604.144.048.045.145.17.145.6h-4.588c0-.43.097-.555.145-.6.048-.045.181-.144.604-.144zm-5.41 3.817v12.293c0 1.27 1.042 2.305 2.319 2.305h9.272c1.277 0 2.319-1.035 2.319-2.305V7.402H5.545zm3.091 2.305h1.546v9.22H8.636v-9.22zm3.091 0h1.546v9.22h-1.546v-9.22zm3.091 0h1.546v9.22h-1.546v-9.22z",
  transform: "translate(-966 -200) translate(166 194) translate(800 6)"
})))));

var SvgIcDelete = function SvgIcDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-delete.995528df.svg";
export { ForwardRef as ReactComponent };